import * as React from 'react';

const Register = () => <h1>Register</h1>;

export default Register;



// WEBPACK FOOTER //
// ./src/components/UserSigning/_Register.tsx